'use strict';

const ObservableEvent = class {
  constructor(newrelic) {
    this.newrelic = newrelic;
  }

  record(name, attributes) {
    if (typeof this.newrelic !== 'object') {
      return;
    }

    this.newrelic.addPageAction(name, attributes || {});
  }
};
const observableEvent = new ObservableEvent(window.newrelic);

export { observableEvent, ObservableEvent };
